export default "__VITE_ASSET__FnaT2Lzl__"